import { useMediaQuery, useTheme } from "@mui/material";
import { useState, useEffect } from "react";
import { SIDEBAR_OPEN } from "../enums";

const useResponsiveConfig = () => {
  const lsSidebar = localStorage.getItem(SIDEBAR_OPEN);
  const [isSidebarOpen, setIsSidebarOpen] = useState(lsSidebar);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Properly handle localStorage access in useEffect
  useEffect(() => {
    setIsSidebarOpen(lsSidebar === "true");
  }, [lsSidebar]);

  const RESPONSIVE_CONFIG = {
    WET_MOVE_STYLE: {
      display: "flex",
      flexDirection: {
        xs: "column",
        sm: "row",
      },
      alignItems: "center",
      gap: 2,
      marginTop: 2,
    },
    FILTER_BUTTON_STYLE: {
      display: { xs: "flex" },
      flexDirection: { xs: "row" },
      justifyContent: { xs: "end", sm: "unset" },
      alignItems: "center",
      width: { xs: "100%", sm: "auto" },
      gap: 2,
    },
    DATAGRID_STYLE: {
      maxWidth: !isSmallScreen
        ? isSidebarOpen
          ? "calc(100vw - 290px)"
          : "calc(100vw - 130px)"
        : "calc(100vw - 50px)",
    },
  };

  return RESPONSIVE_CONFIG;
};

export default useResponsiveConfig;
